import React from 'react';
import { Outlet } from 'react-router-dom';
import CEOSidebar from './CEOSidebar';

const CeoLayout = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <CEOSidebar />
      <main className="flex-1 mt-0">
        <Outlet />
      </main>
    </div>
  );
};

export default CeoLayout;
